import { render } from "./Info.vue?vue&type=template&id=470c432c"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
script.render = render

export default script